export const POST_CATEGORIES = [
    'question',
    'opportunity',
    'onboarding',
    'experience',
    'advice',
    'resource',
    'discussion',
    'announcement',
    'poll',
];
export const REPORT_TARGET_TYPES = ['post', 'comment', 'message', 'profile'];
export const REPORT_REASONS = [
    'confidential_info',
    'harassment',
    'spam',
    'misinformation',
    'other',
];
export const NOTIFICATION_TYPES = [
    'post_like',
    'post_comment',
    'comment_reply',
    'dm_received',
    'platform_broadcast',
    'follow',
    'mention',
    'opportunity',
];
export const NOTIFICATION_TARGET_TYPES = [
    'post',
    'comment',
    'conversation',
    'channel',
    'profile',
];
export const EXPERIENCE_LEVELS = [
    'new_joiner',
    'active_tutor',
    'experienced_tutor',
];
export const AVAILABILITY_STATUSES = [
    'available',
    'limited',
    'unavailable',
];
export const COMPANY_ONBOARDING_SLUGS = [
    'outlier',
    'alignerr',
    'data-annotation',
    'prolific',
    'turing',
];
export const DEFAULT_LANGUAGE = 'en';
//# sourceMappingURL=constants.js.map